import classNames from 'classnames';
import styles from './container.module.scss';

interface ContainerProps extends React.HTMLProps<HTMLDivElement> {
    children: React.ReactNode;
}

export const Container = ({ children, className, ...props }: ContainerProps) => {
    return (
        <div {...props} className={classNames([styles.container, className])}>
            {children}
        </div>
    );
};
